<script setup>
import {computed, onMounted} from "vue";
import store from "@/store";
import {useRoute} from "vue-router";
import QiaopaiStoreLst from "@/components/qiaopai/QiaopaiStoreLst.vue";
import ShuangkeStoresComponents from "@/components/shuangke/ShuangkeStoresComponents.vue";
import {siteConfig} from "@/utils/config";

const type = computed(() => store.state.coupon)
const route = useRoute()

onMounted(() => {
  store.commit("getCoupon")
  document.title = siteConfig[type.value]?.title
})
</script>

<template>
  <qiaopai-store-lst v-if="type === 'qiaopai'"/>
  <shuangke-stores-components v-if="/^shuangke/.test(type)"/>
</template>

<style scoped lang="less">

</style>
